var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('apexcharts',{attrs:{"width":_vm.width,"height":_vm.height,"type":_vm.type,"options":_vm.options,"series":_vm.series}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }